import { Handle, Position } from '@xyflow/react';
import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';


import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
const NodePaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    minWidth: 200,
    backgroundColor: '#ffffff',
    border: `2px solid ${theme.palette.black['100']}`,
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[3],
    '&:hover': {
      boxShadow: theme.shadows[6],
    }
  }));
  
  const StyledHandle = styled(Handle)(({ theme }) => ({
    width: 10,
    height: 10,
    backgroundColor: "black",
    border: "white",
  }));
export function CheckEmailNode() {
  return (
    <NodePaper elevation={3}>
      <StyledHandle
        type="target"
        position={Position.Top}
        isConnectable={true}
      />
      
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        gap: 1,
        py: 1 
      }}>
        <QuestionMarkIcon color="info" />
        <Typography variant="subtitle1" color="info.main">
          Check Email Reply
        </Typography>
      </Box>

      <StyledHandle
        type="source"
        position={Position.Bottom}
        id="yes"
        style={{ left: '25%' }}
        isConnectable={true}
      />
      <Typography variant="caption" color="warning.light" sx={{ position: 'absolute', left: '20%', bottom: -20}} >
        Yes
      </Typography>

      <StyledHandle
        type="source"
        position={Position.Bottom}
        id="no"
        style={{ left: '75%' }}
        isConnectable={true}
      />
      <Typography variant="caption" color="warning.light"sx={{ position: 'absolute', right: '20%', bottom: -20 }}>
        No
      </Typography>
    </NodePaper>
  );
}